"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDiscountProductSortBy = exports.EProductStrainType = exports.ProductDeletedContract = exports.ProductUpdateContract = exports.ProductCreatedContract = exports.ProductEventDataContract = exports.ProductType = exports.ProductSearchFilter = exports.filterProduct = void 0;
const shared_1 = require("@getgreenline/shared");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
const lot_1 = require("./lot");
const taxes_1 = require("./taxes");
const tags_1 = require("@getgreenline/tags");
const price_1 = require("./price");
function filterProduct(product, searchQuery = '') {
    /**
     * Search for:
     * id
     * name
     * sku
     * barcode
     */
    searchQuery = searchQuery.toLowerCase();
    const parentId = product.id;
    const parentName = (product.parentProductName || '').toLowerCase();
    const name = (product.name || '').toLowerCase();
    const parentSku = (product.sku || '').toLowerCase();
    const parentBarcode = product.barcode || '';
    if (parentId === searchQuery ||
        name.includes(searchQuery) ||
        parentName.includes(searchQuery) ||
        parentSku.includes(searchQuery) ||
        parentBarcode.includes(searchQuery)) {
        return true;
    }
    for (const childProduct of product.childProducts) {
        const childId = childProduct.id;
        const childName = (childProduct.name || '').toLowerCase();
        const childSku = (childProduct.sku || '').toLowerCase();
        const childBarcode = childProduct.barcode || '';
        if (childId === searchQuery ||
            childName.includes(searchQuery) ||
            parentName.includes(searchQuery) ||
            childSku.includes(searchQuery) ||
            childBarcode.includes(searchQuery)) {
            return true;
        }
    }
    return false;
}
exports.filterProduct = filterProduct;
class ProductSearchFilter extends shared_1.Pagination {
    constructor(json) {
        super(json);
        this.searchQuery = json.searchQuery;
        this.selectedSupplierId = json.selectedSupplierId;
        this.selectedCategoryIds = json.selectedCategoryIds;
        this.selectedStrainTypes = json.selectedStrainTypes;
        this.selectedTagIds = json.selectedTagIds;
        this.productType = json.productType;
        this.sku = json.sku;
        this.barcode = json.barcode;
        this.isActive = json.isActive;
        this.isDeleted = json.isDeleted;
        this.selectedVendorIds = json.selectedVendorIds;
        this.selectedPricingTemplateIds = json.selectedPricingTemplateIds;
        this.minPrice = json.minPrice;
        this.maxPrice = json.maxPrice;
        this.sortBy = json.sortBy;
        this.sortOrder = json.sortOrder;
        this.selectedBrandIds = json.selectedBrandIds;
    }
}
exports.ProductSearchFilter = ProductSearchFilter;
// If ProductType is updated here, make sure to update homi-shared/src/models/Product.ts too
var ProductType;
(function (ProductType) {
    ProductType["PRODUCT"] = "product";
    ProductType["GIFTCARD"] = "giftCard";
    ProductType["FEE"] = "fee";
    ProductType["TIP"] = "tip";
    ProductType["PAYMENT_FEE"] = "paymentFee";
})(ProductType || (exports.ProductType = ProductType = {}));
class ProductEventDataContract {
}
exports.ProductEventDataContract = ProductEventDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "parentProductId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "parentProductName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "categoryId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "complianceCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "categoryName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "pricingGroupId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "unit", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "inventorySubtractAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "weight", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "cannabisWeight", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "depositFee", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => taxes_1.TaxInProduct)
], ProductEventDataContract.prototype, "taxes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "trackInventory", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "inBetweenPricing", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isCumulative", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isBatchTracked", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "shortDescription", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isGiftCard", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ProductType),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "productType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "sku", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((params) => {
        const value = (0, shared_1.transformCaseInsensitive)(params);
        return (0, shared_1.parseCloudinaryQuality)(value);
    }),
    (0, class_transformer_1.Expose)()
], ProductEventDataContract.prototype, "imageUrl", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "barcode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "shortName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "purchasePrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "cannabisVolume", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "complianceCategoryName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "categoryColorHex", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "parentCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "parentCategoryName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "supplierId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "supplierName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isMasterProduct", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "taxGroupId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "taxGroupName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "wooCommerceProductId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "wooCommerceSyncDate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isPricingGroup", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "trackPurchaseOrderCosts", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "trackConversionCosts", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "updateDate", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "indexOrder", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "thc", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "cbd", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "metaData", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => price_1.MultiLocationPrice),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "overridePrices", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => lot_1.LotContract),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "cannabinoidMetaData", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "strainType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => tags_1.TagModels.TagContract),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], ProductEventDataContract.prototype, "tags", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)()
], ProductEventDataContract.prototype, "globalProductId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)()
], ProductEventDataContract.prototype, "vendorIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)()
], ProductEventDataContract.prototype, "images", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)()
], ProductEventDataContract.prototype, "locationOverrides", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)()
], ProductEventDataContract.prototype, "pricingTemplateId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)()
], ProductEventDataContract.prototype, "taxConfigs", void 0);
class ProductCreatedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ProductEventDataContract, params.product);
    }
}
exports.ProductCreatedContract = ProductCreatedContract;
class ProductUpdateContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ProductEventDataContract, params.product);
    }
}
exports.ProductUpdateContract = ProductUpdateContract;
class ProductDeletedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ProductEventDataContract, params.product);
    }
}
exports.ProductDeletedContract = ProductDeletedContract;
var EProductStrainType;
(function (EProductStrainType) {
    EProductStrainType["SATIVA"] = "Sativa";
    EProductStrainType["SATIVA_DOMINANT"] = "Sativa Dominant";
    EProductStrainType["INDICA"] = "Indica";
    EProductStrainType["INDICA_DOMINANT"] = "Indica Dominant";
    EProductStrainType["HYBRID"] = "Hybrid";
    EProductStrainType["CBD"] = "CBD";
    EProductStrainType["BALANCED"] = "Balanced";
    EProductStrainType["BLEND"] = "Blend";
})(EProductStrainType || (exports.EProductStrainType = EProductStrainType = {}));
var EDiscountProductSortBy;
(function (EDiscountProductSortBy) {
    EDiscountProductSortBy["PRODUCT_NAME"] = "products.name";
    EDiscountProductSortBy["PRODUCT_PRICE"] = "products.price";
    EDiscountProductSortBy["PRODUCT_BARCODE"] = "products.barcode";
    EDiscountProductSortBy["PRODUCT_SKU"] = "products.sku";
    EDiscountProductSortBy["PRODUCT_IS_ACTIVE"] = "products.isActive";
    EDiscountProductSortBy["CATEGORY_NAME"] = "categories.name";
    EDiscountProductSortBy["SUPPLIER_NAME"] = "suppliers.name";
})(EDiscountProductSortBy || (exports.EDiscountProductSortBy = EDiscountProductSortBy = {}));
//# sourceMappingURL=product.js.map